<template>
  <div class="toast" v-bind:class="{display: display}" v-if="ifShow">{{message}}</div>
</template>


<script>
export default {
  data() {
    return {
      display: false,
      message: null,
      timer: null,
      ifShow: true,
    };
  },
  methods: {
    show(message) {
      this.timer && clearTimeout(this.timer)
      this.message = message;
      this.display = true;
      const self = this;
      this.timer = setTimeout(() => {
        self.hide();
      }, 3000);
    },
    hide() {
      this.display = false;
    },
    neverShow() {
      this.ifShow = false
    }
  }
};
</script>
<style scoped>
.toast {
  position: fixed;
  height: 60px;
  line-height: 60px;
  font-size: 12px;
  background-color: #171717;
  color: #fff;
  left: 0px;
  bottom: 0px;
  right: 0px;
  padding: 0px 30px;
  transform: translateY(60px);
  transition: all 0.5s;
  z-index: 999;
}

.toast.display {
  transform: translateY(0);
}
</style>



// WEBPACK FOOTER //
// src/plugins/toast/Toast.vue